import React from 'react';

import * as fonts from '../../../util/fonts';

function Header2({children, ...rest}: any) {
  return (
    <h2 style={{...fonts.ML}} {...rest}>
      {children}
    </h2>
  );
}

export default Header2;
